<template>
	<v-app>
		<v-main>
			<transition name="fade" mode="out-in">
				<router-view />
			</transition>
		</v-main>
	</v-app>
</template>

<style lang="scss">
	@import './assets/scss/main.scss';
</style>

<script>

export default {
	name: 'App'
};
</script>
